module.exports = __webpack_public_path__ + "img/Enmascarar grupo 17@2x.1f437884.png";